import { render } from "./MvtPayment.vue?vue&type=template&id=329b1282"
import script from "./MvtPayment.vue?vue&type=script&lang=js"
export * from "./MvtPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__